import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { orderService, ShopContext } from '../shop/shop-context';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { catchError, take } from 'rxjs/operators';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';

enum DisplayTypes {
	List,
	Grid
}

@Component({ className: 'js-last-ordered-products' })
export class LastOrderedProducts implements OnInit {
	@ComponentRef(ShopContext) shopContext: ShopContext;
	private loader: HTMLElement;
	private target: HTMLElement;
	private contentId: number;
	private pageSize = 10;
	private page = 1;
	private sort = 'default';
	displayType: DisplayTypes;
	displayTypes: NodeListOf<Element>;

	constructor(private element: HTMLElement) {
		this.loader = this.element.querySelector('.js-last-ordered-products__loader');
		this.target = this.element.querySelector('.js-last-ordered-products__result');
		this.contentId = +this.element.getAttribute('data-content-id');
	}

	onInit() {
		const sortSelect = document.querySelector('.js-filter__sort') as HTMLSelectElement;
		if (sortSelect) {
			sortSelect.addEventListener('change', () => {
				this.sort = sortSelect.value;
				this.loadData(this.page);
			});
		}

		// DISPLAY TYPES
		const localDisplayType = localStorage.getItem('shopDisplayType');
		if (localDisplayType) {
			this.displayType = DisplayTypes[localDisplayType];
		}

		this.displayTypes = document.querySelectorAll('.js-filter__display-type');
		this.displayTypes.forEach(type => {
			if (this.displayType === DisplayTypes[type.getAttribute('data-type')]) {
				addClass(type, 'is-active');
			}
			type.addEventListener('click', () => this.changeDisplayType(type));
		});

		this.loadData(this.page);
	}

	private loadData(page: number) {
		removeClass(this.loader, 'd-none');
		this.target.innerHTML = '';
		window.scrollTo(0, 0);

		orderService
			.getLastOrderedProductsPaged(page, this.pageSize, this.contentId, DisplayTypes[this.displayType], this.sort)
			.pipe(catchError(err => '<p>something went wrong</p>'))
			.subscribe(result => {
				addClass(this.loader, 'd-none');
				this.target.innerHTML = result;
				this.page = page;
				this.addEventListeners();
			});
	}

	private addEventListeners() {
		const pageLinks = this.element.querySelectorAll('.js-filter__page-jump');
		pageLinks.forEach(link => link.addEventListener('click', e => this.loadPage(e, link)));

		const next = this.element.querySelector('.js-filter__page-next');
		if (next) {
			next.addEventListener('click', e => this.nextPage(e));
		}

		const prev = this.element.querySelector('.js-filter__page-prev');
		if (prev) {
			prev.addEventListener('click', e => this.prevPage(e));
		}
	}

	private loadPage(event: Event, link: Element) {
		event.preventDefault();
		const page = +link.getAttribute('data-value');
		this.loadData(page);
	}

	private nextPage(event: Event) {
		event.preventDefault();
		this.loadData(this.page + 1);
	}

	private prevPage(event: Event) {
		event.preventDefault();
		this.loadData(this.page - 1);
	}

	private changeDisplayType(type: Element): any {
		this.displayTypes.forEach(t => removeClass(t, 'is-active'));
		addClass(type, 'is-active');

		this.displayType = DisplayTypes[type.getAttribute('data-type')];
		localStorage.setItem('shopDisplayType', DisplayTypes[this.displayType]);
		this.loadData(1);
	}
}
